import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import { Box, Flex } from '@latitude/box';
import { Heading3 } from '@latitude/heading';
import { COLOR, FONT_FAMILY, BREAKPOINT, JUSTIFY_CONTENT, PADDING, MARGIN, FONT_WEIGHT } from '@latitude/core/utils/constants';
import imgConfetti from './rateslist-confetti.png';
const MAX_WIDTH = 170;
const Container = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "RatesListBranded__Container",
  componentId: "sc-xv84g0-0"
})(["justify-content:center;"]);
const RatesList = /*#__PURE__*/styled.div.withConfig({
  displayName: "RatesListBranded__RatesList",
  componentId: "sc-xv84g0-1"
})(["position:relative;display:inline-flex;flex-wrap:wrap;justify-content:center;margin:-", " 0 0 0;max-width:none;> *{margin-top:", ";}@media (min-width:", "){", ";}@media (min-width:", "){", ";}@media (min-width:", "){", ";}@media (min-width:", "){", ";}@media (min-width:", "){:before,:after{content:'';background:center / contain no-repeat url(", ");height:79px;top:-14px;position:absolute;width:54px;}:before{left:-54px;}:after{right:-54px;transform:rotate(180deg);}}"], MARGIN.M16, MARGIN.M16, BREAKPOINT.SM, _ref => {
  let {
    count
  } = _ref;
  return count >= 2 && `max-width: ${(MAX_WIDTH + 2) * 2}px`;
}, BREAKPOINT.MD, _ref2 => {
  let {
    count
  } = _ref2;
  return count >= 3 && `max-width: ${(MAX_WIDTH + 2) * 3}px`;
}, BREAKPOINT.LG, _ref3 => {
  let {
    count
  } = _ref3;
  return count >= 4 && `max-width: ${(MAX_WIDTH + 2) * 4}px`;
}, BREAKPOINT.XL, _ref4 => {
  let {
    count
  } = _ref4;
  return count >= 4 && `max-width: ${(MAX_WIDTH + 2) * 6}px`;
}, BREAKPOINT.MD, imgConfetti);
const RateListItem = /*#__PURE__*/styled(Box).withConfig({
  displayName: "RatesListBranded__RateListItem",
  componentId: "sc-xv84g0-2"
})(["flex-basis:0;padding:", " ", ";border-left:solid 1px ", ";border-right:solid 1px ", ";min-width:130px;max-width:130px;&:nth-child(2n){margin-left:-1px;}@media (min-width:", "){&:nth-child(3n){margin-left:-1px;}&:nth-child(3n + 2){margin-left:-1px;}}@media (min-width:", "){min-width:", "px;max-width:", "px;}"], PADDING.P8, PADDING.P16, COLOR.PURPLE, COLOR.PURPLE, BREAKPOINT.XS, BREAKPOINT.SM, MAX_WIDTH, MAX_WIDTH);
const Extras = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "RatesListBranded__Extras",
  componentId: "sc-xv84g0-3"
})(["margin:-", " 0 0 ", ";flex-direction:column;justify-content:center;font-family:", ";font-size:12px;font-weight:", ";line-height:1;color:", ";"], MARGIN.M4, MARGIN.M4, FONT_FAMILY.TITLE, FONT_WEIGHT.SEMI_BOLD, COLOR.BLUE_DEEP);
const Description = /*#__PURE__*/styled(Box).withConfig({
  displayName: "RatesListBranded__Description",
  componentId: "sc-xv84g0-4"
})(["text-align:center;font-size:12.8px;color:", ";line-height:1.2;"], COLOR.BLACK);
const RatesListBranded = _ref5 => {
  let {
    data
  } = _ref5;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(RatesList, {
    count: data.length
  }, data.map((_ref6, i) => {
    let {
      largeText,
      showExtras = false,
      smallText
    } = _ref6;
    return /*#__PURE__*/React.createElement(RateListItem, {
      key: i,
      count: data.length
    }, /*#__PURE__*/React.createElement(Flex, {
      justifyContent: JUSTIFY_CONTENT.CENTER
    }, largeText && /*#__PURE__*/React.createElement(Heading3, {
      isResponsive: false,
      color: COLOR.BLUE_DEEP,
      marginBottom: MARGIN.M4
    }, largeText), showExtras && /*#__PURE__*/React.createElement(Extras, null, /*#__PURE__*/React.createElement(Box, null, "%"), /*#__PURE__*/React.createElement(Box, null, "p.a."))), smallText && /*#__PURE__*/React.createElement(Description, null, typeof smallText === 'string' ? ReactHtmlParser(smallText) : smallText));
  })));
};
export default RatesListBranded;